import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { FileText, Eye, TrendingUp, Users } from 'lucide-react'

export default function Dashboard() {
  const [stats, setStats] = useState({
    listings: 0,
    active: 0,
    scans: 0,
    leads: 0
  })

  useEffect(() => {
    fetchStats()
  }, [])

  const fetchStats = async () => {
    // Get listings count
    const { count: listingsCount } = await supabase
      .from('listings')
      .select('*', { count: 'exact', head: true })

    // Get active listings
    const { count: activeCount } = await supabase
      .from('listings')
      .select('*', { count: 'exact', head: true })
      .eq('status', 'active')

    // Get scans (last 30 days)
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
    
    const { count: scansCount } = await supabase
      .from('sign_scans')
      .select('*', { count: 'exact', head: true })
      .gte('scanned_at', thirtyDaysAgo.toISOString())

    // Get leads
    const { count: leadsCount } = await supabase
      .from('leads')
      .select('*', { count: 'exact', head: true })

    setStats({
      listings: listingsCount || 0,
      active: activeCount || 0,
      scans: scansCount || 0,
      leads: leadsCount || 0
    })
  }

  const statCards = [
    { label: 'Total Listings', value: stats.listings, icon: FileText, color: 'bg-blue-500' },
    { label: 'Active', value: stats.active, icon: TrendingUp, color: 'bg-green-500' },
    { label: 'Scans (30d)', value: stats.scans, icon: Eye, color: 'bg-purple-500' },
    { label: 'Total Leads', value: stats.leads, icon: Users, color: 'bg-orange-500' },
  ]

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((card) => (
          <div key={card.label} className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center">
              <div className={`${card.color} p-3 rounded-lg`}>
                <card.icon className="w-6 h-6 text-white" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">{card.label}</p>
                <p className="text-2xl font-bold text-gray-900">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Quick Actions</h2>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link
            to="/listings/new"
            className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:border-primary hover:bg-primary/5 transition-colors"
          >
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
              <FileText className="w-5 h-5 text-primary" />
            </div>
            <div>
              <p className="font-medium text-gray-900">Create New Listing</p>
              <p className="text-sm text-gray-500">Add a property to your signs</p>
            </div>
          </Link>

          <Link
            to="/leads"
            className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:border-primary hover:bg-primary/5 transition-colors"
          >
            <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
              <Users className="w-5 h-5 text-orange-600" />
            </div>
            <div>
              <p className="font-medium text-gray-900">View Leads</p>
              <p className="text-sm text-gray-500">Check recent inquiries</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
